import React, { useState } from 'react';
import './Contacto.css';
import { FaInstagram, FaMapMarkerAlt, FaEnvelope, FaPhone, FaChevronDown } from 'react-icons/fa';
import { Helmet } from "react-helmet";
const SITE = "https://juanipavlovsky.com.ar";

const preguntasFrecuentes = [
  {
    pregunta: '¿Cómo puedo adquirir una fotografía?',
    respuesta: 'Podés adquirir una fotografía contactándonos por el formulario o directamente por WhatsApp. Te enviaremos los métodos de pago y el formato disponible.',
  },
  {
    pregunta: '¿Ofrecen sesiones personalizadas?',
    respuesta: 'Sí, realizamos sesiones fotográficas personalizadas. Contanos tu idea y coordinamos juntos.',
  },
  {
    pregunta: '¿Hacen envíos al interior del país?',
    respuesta: 'Sí, hacemos envíos a todo el país mediante correo certificado.',
  },
  {
    pregunta: '¿Puedo pedir una imagen en un tamaño específico?',
    respuesta: 'Claro. Las imágenes están disponibles en varios tamaños. Si buscás uno particular, escribinos y lo resolvemos.',
  },
];

function Contacto() {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    asunto: '',
    mensaje: ''
  });

  const [preguntaAbierta, setPreguntaAbierta] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleEnviar = (e) => {
    e.preventDefault();
    const mensajeWhatsApp = `Hola, soy ${formData.nombre}. Mi email es ${formData.email}. Asunto: ${formData.asunto}. Mensaje: ${formData.mensaje}`;
    const url = `https://wa.me/5491160035550?text=${encodeURIComponent(mensajeWhatsApp)}`; // Reemplazá con el número real
    window.open(url, '_blank');
  };

  const togglePregunta = (index) => {
    setPreguntaAbierta(prev => (prev === index ? null : index));
  };

  return (
    <>
      <Helmet>
        <title>Contacto</title>
        <meta name="description" content="Contactate con Juani Pavlovsky para consultas y proyectos." />
        <link rel="canonical" href={`${SITE}/contacto`} />
        <meta property="og:title" content="Contacto | Juani Pavlovsky" />
        <meta property="og:url" content={`${SITE}/contacto`} />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Inicio", "item": `${SITE}/` },
            { "@type": "ListItem", "position": 2, "name": "Contacto", "item": `${SITE}/contacto` }
          ]
        })}</script>


      </Helmet>
      <div className="contacto-container">
        <div className="contacto-box">
          <h2 className="titulo-contacto">¿Tenés alguna duda?</h2>
          <p className="subtitulo-contacto">¡Estamos para ayudarte! Usá el formulario o escribinos directamente por WhatsApp.</p>

          <form className="formulario-contacto" onSubmit={handleEnviar}>
            <input type="text" name="nombre" placeholder="Nombre" value={formData.nombre} onChange={handleChange} required />
            <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required />
            <input type="text" name="asunto" placeholder="Asunto" value={formData.asunto} onChange={handleChange} required />
            <textarea name="mensaje" placeholder="Mensaje de consulta" value={formData.mensaje} onChange={handleChange} required />
            <button type="submit">Enviar consulta</button>
          </form>

          <div className="info-contacto">
            <h3>Datos Personales</h3>
            <p><FaMapMarkerAlt /> Buenos Aires, Argentina</p>
            <p><FaEnvelope /> juanipavlovsky@hotmail.com</p>
            <p><FaPhone /> +54 9 11 6003-5550</p>

            <div className="redes-sociales">
              <a href="https://www.instagram.com/juanipavlovskyph?igsh=MW4wcngwc2FnODczbQ==" target="_blank" rel="noopener noreferrer" className='icon-instagram'><FaInstagram /></a>
            </div>
          </div>

          <div className="faq-contacto">
            <h3>Preguntas frecuentes</h3>
            {preguntasFrecuentes.map((item, index) => (
              <div key={index} className="pregunta-item">
                <div className="pregunta" onClick={() => togglePregunta(index)}>
                  <span>{item.pregunta}</span>
                  <FaChevronDown className={`flecha ${preguntaAbierta === index ? 'abierta' : ''}`} />
                </div>
                {preguntaAbierta === index && (
                  <div className="respuesta">
                    {item.respuesta}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default Contacto;
